import keymirror from 'keymirror';

export default keymirror({
  SET_BUSINESS_CENTER_PHONE: null,
});



// WEBPACK FOOTER //
// ./src/app/common/appActionKeys.js